/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.0.1
 */

import { cloneElement, Fragment, memo, ReactElement, ReactNode } from 'react';

interface ISkeletonProps {
    count: number;
    children: ReactNode;
    isLoading: boolean;
    render: () => ReactElement;
}

const defaultProps: Partial<ISkeletonProps> = {
    count: 1,
};

const Skeleton = (props: ISkeletonProps) => {
    const renderSkeleton = () =>
        Array.from(Array(props.count).keys())
            .map(index => cloneElement(props.render(), { key: index }));

    return (
        <Fragment>
            {
                props.isLoading
                    ? renderSkeleton()
                    : props.children
            }
        </Fragment>
    );
};

Skeleton.defaultProps = defaultProps;

export default memo(Skeleton);
